/* eslint-disable no-void */

import * as vp from 'vopay';
import { useState, useEffect } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type HookTuple = [
  response: vp.InterestAccountDetailResponse,
  InterestAccountDetailRequest: (params: vp.InterestAccountDetailRequest) => void,
  reset: () => void,
];

type ApiHook = (props: HookProps) => HookTuple;

const usefetchInterestAccountDetail: ApiHook = ({ api }: HookProps) => {
  const source = axios.CancelToken.source();
  const [response, setResponse] = useState<vp.InterestAccountDetailResponse>({
    ErrorMessage: '',
    Success: false,
    InterestAccruedDetails: [],
  });
  const [params, setParams] = useState<vp.InterestAccountDetailRequest>({
    InterestMaturityType: '',
    Month: '',
    Year: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    if (!shouldSendRequest) return () => {};

    const sendRequest = async () => {
      setDataFetchingInfo(true, 'fetching interest account', 'fullScreen');
      const res = await api.fetchInterestAccountDetail(params, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.InterestAccountDetailRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        ErrorMessage: '',
        Success: false,
        InterestAccruedDetails: [],
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usefetchInterestAccountDetail);
